import { DOCUMENT, inject, Pipe, type PipeTransform } from '@angular/core';
import linkifyHtml from 'linkify-html';

@Pipe({
    name: 'linkify',
    standalone: true,
})
export class LinkifyPipe implements PipeTransform {
    protected document = inject(DOCUMENT);
    transform(value: string | null | undefined): string {
        if (!value) return '';

        // Treat input as plain text: escape HTML first, then linkify URLs/emails.
        const escaped = this.escapeHtml(value);
        return linkifyHtml(escaped, {
            defaultProtocol: 'https',
            target: { url: '_blank' },
            className: 'tw:text-primary',
            attributes: {
                rel: 'noopener noreferrer',
            },
        });
    }

    /**
     * Encodes a string so that any potentially unsafe HTML is converted to plain text.
     * Converts &, <, >, ", and ' into their HTML entity equivalents.
     * @param unsafe The potentially unsafe string to encode
     * @returns An HTML-safe encoded string
     */
    private escapeHtml(unsafe: string): string {
        const div = this.document.createElement('div');
        div.innerText = unsafe;
        return div.innerHTML;
    }
}
